import { render } from "./ModalCambioClave.vue?vue&type=template&id=a5342e30&ts=true"
import script from "./ModalCambioClave.vue?vue&type=script&lang=ts"
export * from "./ModalCambioClave.vue?vue&type=script&lang=ts"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__